import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'inProgress'
	| 'needsInput'
	| 'rovoIsThinking'
	| 'agentIsThinking'
	| 'additionalAgents'
	| 'additionalAgentsLabel'
	| 'unreadSessionLabel';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	inProgress: {
		id: 'rovo-platform-ui-components.session-details.inProgress',
		defaultMessage: 'In progress',
		description: 'Accessible label for the indicator shown while a session is in progress.',
	},
	unreadSessionLabel: {
		// eslint-disable-next-line @atlassian/i18n/enforce-id-by-package -- Preserve the existing translation when extracting the unread indicator.
		id: 'ai-inbox.unreadSessionLabel',
		defaultMessage: 'Unread agent session',
		description: 'Accessible label for the unread indicator on an agent session.',
	},
	needsInput: {
		id: 'rovo-platform-ui-components.session-details.needs-input',
		defaultMessage: 'Needs input',
		description: 'Status text shown when a conversation or session requires user input.',
	},
	rovoIsThinking: {
		id: 'rovo-platform-ui-components.session-details.rovo-is-thinking',
		defaultMessage: 'Rovo is thinking...',
		description: 'Status text shown while the default Rovo agent is preparing a response.',
	},
	agentIsThinking: {
		id: 'rovo-platform-ui-components.session-details.agent-is-thinking',
		defaultMessage: 'Agent is thinking...',
		description: 'Status text shown while a non-default agent is preparing a response.',
	},
	additionalAgents: {
		id: 'rovo-platform-ui-components.session-details.additional-agents',
		defaultMessage: '+{count} more',
		description:
			'Visible label that indicates how many additional agents participated in a session.',
	},
	additionalAgentsLabel: {
		id: 'rovo-platform-ui-components.session-details.additional-agents-label',
		defaultMessage: '{count} more agents',
		description:
			'Accessible label that indicates how many additional agents participated in a session.',
	},
});
